import React from "react"
import { useStaticQuery, graphql } from "gatsby"

export const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            title
            email
            menuLinks {
              route
              title
            }
          }
        }
      }
    `
  )
  return site.siteMetadata
}